import { User } from '../types/common';

/**
 * Returns predefined display name of User type
 * 1. name
 * 2. first name last initial
 * 3. first name
 * 4. last name
 * else "My account" (fallback)
 */
export function getUserDisplayName({
  name,
  firstName,
  lastName,
}: Partial<User>): string {
  if (name) {
    return name;
  }
  if (firstName && lastName) {
    return `${firstName} ${lastName.slice(0, 1)}`;
  }
  if (firstName) {
    return firstName;
  }
  if (lastName) {
    return lastName;
  }
  return 'My account';
}
